import React from 'react'

class DiscoverRepoListHeaderToggleItem extends React.Component{

	render(){
		const {subject,selectSubSubject,selectedSubSubject}=this.props
		const active=subject==selectedSubSubject?true:false


		return(
			<button onClick={()=>{selectSubSubject(subject)}}className={'discover-repoList-header-toggleItem ' + (active ? 'discover-repoList-header-toggleItem--active' :'discover-repoList-header-toggleItem--inactive')}>
				{this.props.label}
			</button>
		)
	} 
}


class DiscoverRepoListHeader extends React.Component{

	render(){
		const {selectSubSubject,selectedSubSubject}=this.props
		
		return(
			<div className='discover-repoList-header'>
				<div className='discover-repoList-header-toggleGroup discover-repoList-header-toggleGroup--subject'>
					<DiscoverRepoListHeaderToggleItem 
						label='All Packs' 
						subject={null} 
						selectedSubSubject={selectedSubSubject}
						selectSubSubject={selectSubSubject}
					/>
					<DiscoverRepoListHeaderToggleItem 
						label='Biology' 
						subject='biology'
						selectedSubSubject={selectedSubSubject}
						selectSubSubject={selectSubSubject}
					/>
					<DiscoverRepoListHeaderToggleItem 
						label='Chemistry' 
						subject='chemistry'
						selectedSubSubject={selectedSubSubject}
						selectSubSubject={selectSubSubject}
					/>
					<DiscoverRepoListHeaderToggleItem 
						label='Earth Sci' 
						subject='earthScience'
						selectedSubSubject={selectedSubSubject}
						selectSubSubject={selectSubSubject} 
					/>
					<DiscoverRepoListHeaderToggleItem 
						label='Physics' 
						subject='physics' 
						selectedSubSubject={selectedSubSubject}
						selectSubSubject={selectSubSubject}
					/>
				</div>
				{/*
				<div className='discover-repoList-header-toggleGroup discover-repoList-header-toggleGroup--grade'>
					<DiscoverRepoListHeaderToggleItem active label='Grade 6' />
					<DiscoverRepoListHeaderToggleItem active label='Grade 7' />
					<DiscoverRepoListHeaderToggleItem active label='Grade 8' />
					<DiscoverRepoListHeaderToggleItem active label='Grade 9' />					
				</div>
				*/}
				<div className='discover-repoList-header-spacer' />
				<div className='discover-repoList-header-packCount'>
					{this.props.repoCount} results
				</div>				

				{/*<div className='discover-repoList-header-toggleGroup discover-repoList-header-toggleGroup--sortOrder'>					
					<DiscoverRepoListHeaderToggleItem active label='A-Z' />
					<DiscoverRepoListHeaderToggleItem label='Newest' />					
				</div>
					*/}				


			</div>
		)
	}
}


export default DiscoverRepoListHeader

